import React, { useEffect, useState, useCallback } from "react";
import style from "./VendorCountCard.module.css";
import blockStyle from "./Blocks.module.css";
import CommonButton from "../CommonButton";
import FilterPopIcon from "../../Images/Svg/FilterPopIcon.svg";
import VendorLocationCard from "./VendorLocationCard";
import useToaster from "../../customHook/useToaster";
import { Typography, Box, TextField, Popper, Paper } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import WhiteFilter from "../../Images/Svg/whiteFilter.svg";
import FilterModal from "./FilterModal";
import { images } from "../../Images/Svg";
import { useSelector } from "react-redux";

const { FilledCancelIcon } = images;

const theme = createTheme({
  palette: {
    textField_bordercolor: {
      main: "#CCC",
    },
  },
});

const buttonStyle = {
  fontSize: "2.8rem",
  paddingTop: "0.4rem",
  paddingBottom: "0.4rem",
  color: "white",
};

const VendorCountCard = ({
  isReassign = false,
  reassignType = "",
  Vendorcount = 0,
  VendorsData = [],
  assignedBlocksData = [],
  dropdownData = [],
  isFilterPopOverActive = false,
  blockDetails = null,
  handleClick = () => {},
  setDataToSend = () => {},
  onAssign = () => {},
  onRemoveItem = () => {},
  anchorEl,
  id,
}) => {
  const [remarks, setRemarks] = useState("");
  const [locationDropdownStatus, setLocationDropdownStatus] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({
    state: "",
    city: "",
    blocks: [],
  });
  const [filters, setFilters] = useState({
    state: "",
    city: "",
    blocks: [],
    isApplied: false,
  });
  const { showToast } = useToaster();
  const isAllocatedCase = useSelector(
    (state) => state?.CaseDescriptionSlice?.isAllocatedCase
  );
  const handleRemarkChange = (e) => {
    setRemarks(e.target.value);
  };

  const locationDropClickHandler = (index) => {
    setLocationDropdownStatus((prev) => {
      const updatedStatus = [...prev];
      updatedStatus[index] = {
        ...updatedStatus[index],
        isToggle: !updatedStatus[index].isToggle,
      };
      return updatedStatus;
    });
  };

  const assignHandler = useCallback(() => {
    if (VendorsData?.length) {
      let isNotLoaction = VendorsData?.find((obj) => !obj?.state || !obj?.city);
      if (isNotLoaction) {
        return showToast("Please provide vendor location.", "warning", true);
      }
      if (isReassign && !remarks) {
        return showToast("Please provide rejection remark.", "warning", true);
      }
      onAssign(VendorsData, remarks);
    } else {
      showToast("Please select vendor blocks.", "warning", true);
    }
  }, [VendorsData, remarks, isReassign]);

  useEffect(() => {
    let locationStatusObj = Array(Vendorcount)
      ?.fill("")
      ?.map((val, id) => ({
        id,
        isToggle: false,
      }));
    setLocationDropdownStatus([...locationStatusObj]);
  }, [Vendorcount]);

  return (
    <>
      <div className={style["main_card_container"]}>
        {Vendorcount ? (
          <>
            <div className={style["btn"]}>
              <div className={blockStyle["filter_blocks_container"]}>
                {filters?.blocks?.map((item) => (
                  <h1
                    key={`filter_${item?.block_master_id}`}
                    className={blockStyle["filter_blocks"]}
                  >
                    {item?.block_name}
                  </h1>
                ))}
              </div>

              <CommonButton
                onClick={handleClick}
                fitContent
                label=""
                id="filter"
                isIcon={true}
                // arialabel={id}
                iconName={
                  <img
                    src={
                      isFilterPopOverActive || filters?.isApplied
                        ? WhiteFilter
                        : FilterPopIcon
                    }
                    alt="Filter Icon"
                    style={buttonStyle}
                  />
                }
                isColor
                backgroundColor={
                  isFilterPopOverActive || filters?.isApplied
                    ? "#E42125"
                    : "#FAFAFA"
                }
                textColor={
                  isFilterPopOverActive || filters?.isApplied
                    ? "#FFFFFF"
                    : "#E42125"
                }
                removeBorder
                isHover
                hoverColor={
                  isFilterPopOverActive || filters?.isApplied
                    ? "#E42125"
                    : "#FAFAFA"
                }
                filledButton={false}
                sx={{
                  width: "4rem",
                  height: "4rem",
                  zIndex: isFilterPopOverActive ? "2" : 0,
                }}
              />
              <FilterModal
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                filters={filters}
                setFilters={setFilters}
                closeFilter={handleClick}
                blockDetails={blockDetails}
                dropdownData={dropdownData}
                isFilterPopOverActive={isFilterPopOverActive}
                anchorEl={anchorEl}
                id={id}
              />
            </div>
            {/* <Popper
              id={id}
              open={isFilterPopOverActive}
              anchorEl={anchorEl}
              transition
              placement={"bottom-end"}
            > */}

            {/* </Popper> */}
            <div className={style["vendor_count_container"]}>
              {VendorsData?.map((item, idx) => {
                let isVisible =
                  !filters?.isApplied ||
                  (filters?.state &&
                    filters?.city &&
                    VendorsData[idx]?.state === filters?.state &&
                    VendorsData[idx]?.city === filters?.city) ||
                  (filters?.blocks?.length &&
                    filters?.blocks?.some((block) =>
                      VendorsData[idx]?.blocksAssigned?.includes(
                        block?.block_master_id
                      )
                    ));
                return (
                  <div
                    key={`vendor_${idx + 1}`}
                    className={`${!isVisible ? style["hidden"] : ""}`}
                  >
                    <h1 className={style["vendor_count"]}>{`Vendor ${
                      idx + 1
                    }`}</h1>
                    <div className={style["vendor-container"]}>
                      <VendorLocationCard
                        vendorId={idx + 1}
                        isReassign={isReassign}
                        reassignType={reassignType}
                        dataToSend={VendorsData}
                        setDataToSend={setDataToSend}
                        dropdownData={dropdownData}
                        isLocationSelectOpen={
                          locationDropdownStatus?.[idx]?.isToggle
                        }
                        locationDropClickHandler={() =>
                          locationDropClickHandler(idx)
                        }
                      />

                      <div
                        className={blockStyle["blocks_container"]}
                        style={{ padding: "1rem", gap: "1.5rem" }}
                      >
                        {assignedBlocksData?.map((item) =>
                          item?.investigator?.includes(idx + 1) ? (
                            <h1
                              key={item?.block_master_id}
                              className={blockStyle["blocks"]}
                              style={{
                                border: "0.50px #339DFF solid",
                                display: "flex",
                                position: "relative",
                              }}
                            >
                              {item?.block_name}
                              <div
                                className={style["cancel-icon"]}
                                style={{
                                  display: isAllocatedCase
                                    ? "flex"
                                    : item?.isPrevSelected && idx === 0
                                    ? "none"
                                    : "flex",
                                }}
                                onClick={(e) =>
                                  onRemoveItem(item?.block_master_id, idx + 1)
                                }
                              >
                                <img
                                  width="100%"
                                  height="100%"
                                  src={FilledCancelIcon}
                                  alt="cancel"
                                />
                              </div>
                            </h1>
                          ) : null
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <p className={style["select_count"]}>
            Select count of vendors to assign blocks
          </p>
        )}
      </div>

      {isReassign && (
        <Box
          component="form"
          sx={{
            "& .MuiInputBase-root": {
              padding: "10px",
            },
            marginTop: "2rem",
          }}
          noValidate
          autoComplete="off"
        >
          <div>
            <Typography sx={{ color: "#7C7C7C", fontSize: "1.4rem" }}>
              Remarks
            </Typography>
          </div>
          <div>
            <ThemeProvider theme={theme}>
              <TextField
                inputProps={{
                  style: { fontSize: "1.2rem", lineHeight: "1.8rem" },
                }}
                sx={{ width: "100%" }}
                color="textField_bordercolor"
                multiline
                margin="none"
                placeholder="Enter Remarks"
                rows={3}
                value={remarks}
                onChange={handleRemarkChange}
              />
            </ThemeProvider>
          </div>
        </Box>
      )}

      <div
        style={{
          marginTop: "1.7rem",
          marginLeft: "auto",
          marginRight: "auto",

          display: "flex",
          justifyContent: "center",
        }}
      >
        <CommonButton
          fitContent
          label="Assign"
          isColor
          backgroundColor={assignedBlocksData?.length ? "#E42125" : "#E4212580"}
          textColor={assignedBlocksData?.length ? "white" : "#E42125"}
          removeBorder
          isHover
          hoverColor={"#E4212580"}
          sx={{ padding: "0 2.5rem" }}
          onClick={assignHandler}
        />
      </div>
    </>
  );
};

export default VendorCountCard;
